import { render } from "./ModalRealoadPage.vue?vue&type=template&id=4575538c"
import script from "./ModalRealoadPage.vue?vue&type=script&lang=js"
export * from "./ModalRealoadPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__